import { render, staticRenderFns } from "./ManagementSystem.vue?vue&type=template&id=7fd220da&"
import script from "./ManagementSystem.vue?vue&type=script&lang=ts&"
export * from "./ManagementSystem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports